<script setup lang="ts">
import type { Block } from 'types/index';

type Props = {
  blocks: Block[];
};

defineProps<Props>();
</script>

<template>
  <div class="block-list">
    <template
      v-for="(block, index) in blocks"
      :key="`block-${index}-${block.alias}`"
    >
      <BlockListItem
        v-if="block.content && block.alias"
        :block="block"
      />
    </template>
  </div>
</template>
